import { Model } from '@vuex-orm/core';
import http from '@/services/http';

export default class StoreDeliveryTier extends Model {
  static entity = 'storeDeliveryTiers';

  static primaryKey = 'id';

  // FIELDS //////////////////////
  static fields() {
    return {
      id: this.attr(null),
      storeId: this.attr(null),
      tierLevel: this.attr(null),
      tierMinAmount: this.attr(null),
      tierMaxAmount: this.attr(null),
      tierFeeAmount: this.attr(null),
      feeTypeId: this.attr(null),
      deliveryServiceId: this.attr(null),
      platformTypeId: this.attr(null)
    };
  }

  // STATE //////////////////////
  static state() {
    return {
      fetching: false,
      updating: false
    };
  }

  static $state() {
    return this.store().state.entities.storeDeliveryTiers;
  }

  // ACTIONS //////////////////////
  static async fetchTiers(storeId) {
    try {
      this.commit((state) => {
        state.fetching = true;
      });

      const { data } = await http.get(`stores/${storeId}/delivery_tiers`);

      this.insert({ data: data.storeDeliveryTiers });

      return data.storeDeliveryTiers;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.fetching = false;
      });
    }
  }

  static async bulkReplaceTiers({ storeId, tiers }) {
    try {
      this.commit((state) => {
        state.updating = true;
      });

      const { data } = await http.post(`stores/${storeId}/delivery_tiers/bulk_replace`, {
        store_delivery_tiers: tiers
      });

      const tiersToDelete = this.query()
        .where('deliveryServiceId', tiers[0].deliveryServiceId)
        .where('platformTypeId', tiers[0].platformTypeId)
        .where('storeId', storeId)
        .get();

      tiersToDelete.forEach((item) => {
        item.$delete();
      });


      this.insert({ data: data.storeDeliveryTiers });

      return data.storeDeliveryTiers;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.updating = false;
      });
    }
  }
}
